var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 28,
    viewBox: "0 0 128 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.32 1.72L9.90629 19.9497C9.32942 21.1996 8.07846 22 6.70187 22H6.42794C5.66732 22 4.93785 21.6978 4.4 21.16",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.72L11.0001 17.1999",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 8.44V21.88",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.32 8.44V11.98C23.32 14.9292 25.7108 17.32 28.66 17.32V17.32C31.6092 17.32 34 14.9174 34 11.9682V11.9682",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.24 8.32001V21.76",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40 8.32001V15.64C40 19.02 42.74 21.76 46.12 21.76V21.76C49.5 21.76 52.24 19.02 52.24 15.64V13.66",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67 22V2L77 20.8673",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87 22V2L77 20.8673",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.48 20.24V20.24C103.279 21.2477 101.761 21.8 100.192 21.8L99.8 21.8C96.1549 21.8 93.2 18.8451 93.2 15.2V14.78M93.2 14.78V14.24C93.2 10.7937 95.9937 8 99.44 8V8C102.886 8 105.68 10.7937 105.68 14.24V14.3563C105.68 14.5903 105.49 14.78 105.256 14.78H93.2Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M112 22L118 8L124 22",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M126 26V22H110V26",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/Name.2fc8c18f29ab523349eb555a7064e4ca.svg";
export { ForwardRef as ReactComponent };